// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PostStats--wrapper--A1XvJ","author":"PostStats--author--3kkhh","profileImage":"PostStats--profileImage--3qdGX","dot":"PostStats--dot--kvdgr"};